// extracted by mini-css-extract-plugin
module.exports = {"modal-container":"index__modal-container__2yzgX","btn":"index__btn__1TmLr","btn-complete":"index__btn-complete__1r-FG","btn-cancel":"index__btn-cancel__17Psw"};